import React, { Component } from 'react';
import Page from '../components/Page'; 
import Flexbox from '../components/misc/Flexbox'; 

class PageContainer extends Component {
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	
		if(this.props.resolves.name==='information'){
			setTimeout(function(){
				document.getElementById('menu-informationen').classList.add('active');
			},400);
		}
		if(this.props.resolves.name==='besuch'){
			setTimeout(function(){
				document.getElementById('menu-besuch').classList.add('active');
			},400);
		}
	}
	componentWillUnmount(){
		if(this.props.resolves.name==='information'){
			document.getElementById('menu-informationen').classList.remove('active');
		}
		if(this.props.resolves.name==='besuch'){
			document.getElementById('menu-besuch').classList.remove('active');
		}
	}
	render() {		   
		   const { page } = this.props.resolves;
		   return (
				<div className="container-fluid lg-side-padding">
					<div className="row">
						<div className="col-md-12">
							<Flexbox left={page.title_left} right={page.title_right} />
							<Page {...page} /> 
						</div>
					</div>
				</div>
			)
	   
	}
}
export default PageContainer;


// WEBPACK FOOTER //
// ./src/containers/PageContainer.js